import { COLOR_HEX_FORMAT } from 'tools/validation'

const uploadCarePathRegex = /^https:\/\/ucarecdn.com\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\//i

const uploadCareCropRegex = /.*\/(-\/crop\/\d+x\d*\/[^/]*\/)/i

const isUploadcareUrl = (url) => url && url.match(uploadCarePathRegex)

const executeIfUploadcareUrl = (fn, argsValidation = () => true) => (url, ...args) => {
  if (argsValidation(...args) && isUploadcareUrl(url)) return fn(url, ...args)
  return url
}

const modifierValidation = {
  preview: (dimensions) => typeof dimensions === 'string' && dimensions.match(/^[0-9]+x[0-9]+$/),
  resize: (dimensions) => typeof dimensions === 'string' && (dimensions.match(/^[0-9]*x[0-9]+$/) || dimensions.match(/^[0-9]+x[0-9]*$/)),
  progressive: (param) => param === 'yes' || param === 'no',
  format: (param) => ['jpeg', 'png', 'webp', 'auto'].some(x => x === param),
  stretch: (mode) => ['on', 'off', 'fill'].some(x => x === mode),
  setfill: (color) => typeof color === 'string' && COLOR_HEX_FORMAT.test(color)
}

const preview = executeIfUploadcareUrl(
  (url, dimensions) => url.includes('/-/preview')
    ? url.replace(/\/-\/preview\//, `/-/preview/${dimensions}/`)
    : `${url}-/preview/${dimensions}/`,
  modifierValidation.preview
)

const resize = executeIfUploadcareUrl(
  (url, dimensions) => `${url}-/resize/${dimensions}/`,
  modifierValidation.resize
)

const progressive = executeIfUploadcareUrl(
  (url, param) => `${url}-/progressive/${param}/`,
  modifierValidation.progressive
)

const format = executeIfUploadcareUrl(
  (url, param) => `${url}-/format/${param}/`,
  modifierValidation.format
)

const stretch = executeIfUploadcareUrl(
  (url, mode) => `${url}-/stretch/${mode}/`,
  modifierValidation.stretch
)

const setfill = executeIfUploadcareUrl(
  (url, color) => `${url}-/setfill/${color}/`,
  modifierValidation.setfill
)

const modifierFunctions = {
  preview,
  resize,
  progressive,
  format,
  stretch,
  setfill
}

const defaultModifiers = { format: 'auto' }

export const getNamelessUploadcareUrl = (url) => {
  const matched = url && url.match(uploadCarePathRegex)
  return (matched && matched[0]) || url
}

const getUploadcareCropPath = (url) => {
  const cropPath = url && url.match(uploadCareCropRegex)
  return (cropPath && cropPath[1])
}

const limit = (value) => Math.ceil(Math.min(value, 3000))

const ratios = [0.25, 0.5, 1, 2, 3, 4]
export const generateImageSources = ({
  url = '',
  baseW
}) => {
  let cleanUrl = getNamelessUploadcareUrl(url)
  const cropPath = getUploadcareCropPath(url)
  cleanUrl = cropPath ? `${cleanUrl}${cropPath}` : cleanUrl
  const src = applyUploadcareModifiers(cleanUrl, { resize: `${limit(baseW)}x` })
  const srcSet = ratios.map(ratio => `${applyUploadcareModifiers(cleanUrl, { resize: `${limit(ratio * baseW)}x` })} ${limit(ratio * baseW)}w`).join(', ')
  return { src, srcSet }
}

export const applyUploadcareModifiers = (url, _modifiers = {}) => {
  const modifiers = { ...defaultModifiers, ..._modifiers }
  return Object.keys(modifiers).reduce(
    (acc, key) => typeof modifierFunctions[key] === 'function' ? modifierFunctions[key](acc, modifiers[key]) : acc,
    url
  )
}
